import React, { useState, useEffect, useRef, useContext } from 'react'
import { JumpLinkLists } from '@type/component-data-types.d'
import { Accordion } from 'react-bootstrap'
import { Dash, Plus, FilterLeft } from 'react-bootstrap-icons'
import { LayoutScrollContext } from '@components/_Layout/Layout'

type Props = {
  linkItem: JumpLinkLists
  isStickyEnabled?: boolean
  className?: string | null
}

const DEFAULT_JUMP_LINKS_CLASS_NAME = 'jumpLinks'

const JumpLinks = ({
  linkItem,
  isStickyEnabled = false,
  className = null,
}: Props): React.JSX.Element => {
  const [toggleState, setToggleState] = useState(true)
  const [stickyToggleState, setStickyToggleState] = useState(false)
  const sentinelRef = useRef<HTMLDivElement | null>(null)
  const { isJumpLinksSticky, registerJumpLinksSentinel } =
    useContext(LayoutScrollContext)

  useEffect(() => {
    if (sentinelRef.current) {
      registerJumpLinksSentinel(sentinelRef.current)
    }
  }, [])

  const mergedClassName = className
    ? `${DEFAULT_JUMP_LINKS_CLASS_NAME} ${className}`
    : `${DEFAULT_JUMP_LINKS_CLASS_NAME}`

  /**
   * 目次のリスト部分をレンダリングする共通関数
   */
  const renderLinksList = (): React.JSX.Element => (
    <ul>
      {linkItem.map((elm, index) => (
        <li key={`jump-link-${index}`}>
          <a href={elm.href}>{elm.section}</a>
        </li>
      ))}
    </ul>
  )

  return (
    <>
      <div className={mergedClassName}>
        <Accordion defaultActiveKey={['0']} alwaysOpen flush>
          <Accordion.Item eventKey="0">
            <div
              className="jumpLinks__toggle"
              onClick={() => setToggleState(!toggleState)}
            >
              <FilterLeft className="jumpLinks__toggleIcon" />
              目次
              {toggleState ? (
                <Dash className="jumpLinks__toggleIcon" />
              ) : (
                <Plus className="jumpLinks__toggleIcon" />
              )}
            </div>
            {toggleState && (
              <Accordion.Body className="jumpLinks__body">
                {renderLinksList()}
              </Accordion.Body>
            )}
          </Accordion.Item>
        </Accordion>

        <div ref={sentinelRef} style={{ height: '1px' }} />
      </div>

      {isStickyEnabled && isJumpLinksSticky && (
        <div className="jumpLinks jumpLinks--sticky">
          <div
            className="jumpLinks__toggle"
            onClick={() => setStickyToggleState(!stickyToggleState)}
          >
            <FilterLeft className="jumpLinks__toggleIcon" />
            目次
            {stickyToggleState ? (
              <Dash className="jumpLinks__toggleIcon" />
            ) : (
              <Plus className="jumpLinks__toggleIcon" />
            )}
          </div>
          {stickyToggleState && (
            <div
              className="jumpLinks__body"
              onClick={() => setStickyToggleState(!stickyToggleState)}
            >
              {renderLinksList()}
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default JumpLinks
